require('jquery-validation');
require('jquery-validation-unobtrusive');
require('../vendors/sitecore/jquery.unobtrusive-ajax.min');
require('../vendors/sitecore/form.validate');
require('../vendors/sitecore/form.tracking');
var _remove = require('lodash/remove');

(function ($) {
    if ($.validator) {
        if ($.validator.unobtrusive && $.validator.unobtrusive.adapters) {
            var adapters = $.validator.unobtrusive.adapters;
            if (adapters) {
                // the ischecked validator is unnecessary since we are already providing our own for checkbox lists (checkboxtrue)
                _remove(adapters, adapter => adapter.name === "ischecked");
            }
        }

        if ($.validator.methods) {
            // replace the existing daterange validation method with one that correctly formats the date from the datepicker
            _remove($.validator.methods, method => method.name === "daterange");
            $.validator.addMethod(
                "daterange",
                function (value, element, params) {
                    let formattedValue = $.datepicker ? $.datepicker.formatDate('yy-mm-dd', new Date(value)) : value;
                    return this.optional(element) || (formattedValue >= params.min && formattedValue <= params.max);
                });
        }
    }
})(jQuery);